module.exports = __webpack_public_path__ + "img/icon_mensageria_hover.49ac7884.png";